import React, { useEffect } from 'react'
import './toggle-input.styles.scss';
import { useSelector } from 'react-redux';

const ToggleInput = ({ contentKey, checked, saveData, value, disabled }) => {

    const screenSize = useSelector(state => state.contentData.screenSize);
    
    useEffect(() => {
        // console.log(contentKey);
    }, [contentKey])

    return (
        <div className={`toggle-input ${disabled ? 'disabled' : ''} ${screenSize}`}>
            <input 
                className='toggle' 
                type='checkbox' 
                checked={checked ?? false} 
                onChange={(e) => saveData(contentKey, value ?? e.target.checked)} 
            />
        </div>
    )
}

export default ToggleInput